import React from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'components/Popup/popup';
import { Dropdown } from 'components/Dropdown/Dropdown';
import ReassignWarningPopup from './ReassignWarningPopup';

class ReassignMultiplePopup extends React.Component {
  static propTypes = {
    onSaveReassignPopup: PropTypes.func,
    onCancelReassignPopup: PropTypes.func,
    sso: PropTypes.bool,
    userSelectList: PropTypes.array,
    onFetchUser: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      user: null,
      isLoadingUser: false,
      isOpenWarningPopup: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userSelectList) {
      this.setState({ isLoadingUser: false });
    }
  }

  onSave = () => {
    this.props.onSaveReassignPopup(this.state.user);
  };

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
  };

  fetchUser = () => {
    this.setState(
      {
        isLoadingUser: true
      },
      () => {
        this.props.onFetchUser();
      }
    );
  };

  render() {
    const { sso, userSelectList } = this.props;

    const { isLoadingUser, user, isOpenWarningPopup } = this.state;

    const disabled = !user;

    return (
      <React.Fragment>
        <Popup
          ref={ref => {
            this.reassignMultiple = ref;
          }}
          isHasFaded={true}
          className='close-multi-popup work-order-info-wrapper'
        >
          <div className='form-group' style={{ marginBottom: 0 }}>
            <p style={{ fontSize: 14, padding: '0 16px' }}>
              Select another builder rep to assign the selected requests for
              service.
            </p>
            <label className='col-sm-12 control-label form-siteone-label'>
              RFS managed by
            </label>
            <div className='col-sm-12'>
              <Dropdown
                onChange={ref => {
                  this.onSelectChange(ref, 'user');
                }}
                filter={true}
                className='filestring-dropdown filter-dropdown'
                onRemote={this.fetchUser}
                options={userSelectList.map(item => {
                  return {
                    ...item,
                    text: `${item.text} (${item.extensionValue.email})`
                  };
                })}
                loading={isLoadingUser}
                optionLabel='text'
                value={user}
                showClear={true}
                groupLabels={
                  sso
                    ? [
                      {
                        label: 'System users',
                        field: 'sso',
                        condition: [true]
                      },
                      {
                        label: 'Builder users',
                        field: 'sso',
                        condition: [false, null]
                      }
                    ]
                    : null
                }
                name='user'
                placeholder='-- Please select'
                style={{ width: '100%', paddingLeft: 0, paddingRight: 5 }}
              />
            </div>
          </div>
          <ul
            className='wo-popup-bottom-btn'
            style={{ marginTop: 0, borderTop: 0, marginBottom: 15 }}
          >
            <li>
              <button
                className='btn btn-primary btn-siteone-default btn-wo-edit'
                onClick={this.props.onCancelReassignPopup}
              >
                Cancel
              </button>
            </li>
            <li>
              <button
                className='btn btn-primary btn-siteone'
                onClick={() => {
                  this.setState({ isOpenWarningPopup: true });
                }}
                disabled={disabled}
              >
                Reassign
              </button>
            </li>
          </ul>
        </Popup>
        <ReassignWarningPopup
          isOpen={isOpenWarningPopup}
          onClose={this.props.onCancelReassignPopup}
          onProceed={this.onSave}
        />
      </React.Fragment>
    );
  }
}

export default ReassignMultiplePopup;



// WEBPACK FOOTER //
// ./src/Request-Services/Components/ReassignMultiplePopup.js